import { useState } from 'react';
import axios from 'axios';
import { API_URL } from '../../config';
import { getToken, inputStyle, labelStyle } from './utils';

// Modal pra cadastrar serviço novo (chamado de dentro do ModalSelecionarServico)
export default function ModalCadastrarServico({ nomeInicial, onClose, onCriado }: {
  nomeInicial?: string;
  onClose: () => void;
  onCriado: (novo: any) => void;
}) {
  const [nome, setNome] = useState(nomeInicial || '');
  const [area, setArea] = useState('Outros');
  const [unidade, setUnidade] = useState('vb');
  const [codigo, setCodigo] = useState('');
  const [cnae, setCnae] = useState('');
  const [salvando, setSalvando] = useState(false);

  // Default do código de serviço da NF pela área (de-para Lucas 2026-07-27).
  function cnaeDefaultDaArea(a: string): string {
    if (/topografia/i.test(a)) return '07.20.02';
    if (/hidrometria/i.test(a)) return '07.20.03';
    if (/estudos|ambiental/i.test(a)) return '07.03.01';
    if (/projetos/i.test(a)) return '07.03.02';
    return '';
  }

  async function salvar() {
    if (!nome.trim()) { alert('Nome obrigatório'); return; }
    setSalvando(true);
    try {
      const token = await getToken();
      const res = await axios.post(`${API_URL}/comercial/servicos-produtos`, {
        nome: nome.trim(),
        area, unidade,
        codigo: codigo.trim() || null,
        cnae: (cnae || cnaeDefaultDaArea(area)) || null,
      }, { headers: { Authorization: token } });
      const data = res.data.body ? JSON.parse(res.data.body) : res.data;
      onCriado(data);
    } catch (e: any) {
      alert('Erro: ' + (e.response?.data?.error || e.message));
    } finally { setSalvando(false); }
  }

  return (
    <div style={{
      position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.55)',
      display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 3000,
    }} onClick={onClose}>
      <div onClick={e => e.stopPropagation()}
        style={{ background: '#fff', borderRadius: 10, padding: 22, width: '94%', maxWidth: 480 }}>
        <h3 style={{ margin: '0 0 16px', fontSize: 14, color: '#020D7F' }}>+ Cadastrar novo serviço</h3>

        <label style={labelStyle}>Nome *</label>
        <input value={nome} onChange={e => setNome(e.target.value)} autoFocus
          style={inputStyle} />

        <label style={{ ...labelStyle, marginTop: 10 }}>Área *</label>
        <select value={area} onChange={e => setArea(e.target.value)} style={inputStyle}>
          <option value="Topografia">Topografia</option>
          <option value="Hidrometria">Hidrometria</option>
          <option value="Estudos">Estudos (hidrologia, hidráulica)</option>
          <option value="Projetos">Projetos</option>
          <option value="Outros">Outros</option>
        </select>

        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10, marginTop: 10 }}>
          <div>
            <label style={labelStyle}>Unidade</label>
            <input value={unidade} onChange={e => setUnidade(e.target.value)}
              placeholder="Ex.: vb, h, dia, km, m, m²" style={inputStyle} />
          </div>
          <div>
            <label style={labelStyle}>Código (opcional)</label>
            <input value={codigo} onChange={e => setCodigo(e.target.value)}
              placeholder="Ex.: TOP-01" style={inputStyle} />
          </div>
        </div>

        <label style={{ ...labelStyle, marginTop: 10 }}>Código de serviço da NF (CNAE)</label>
        <select value={cnae || cnaeDefaultDaArea(area)} onChange={e => setCnae(e.target.value)} style={inputStyle}>
          <option value="">— sem código —</option>
          <option value="07.03.01">07.03.01 — Estudos/planos de engenharia</option>
          <option value="07.03.02">07.03.02 — Projetos (anteprojeto/básico/executivo)</option>
          <option value="07.20.02">07.20.02 — Topografia terrestre</option>
          <option value="07.20.03">07.20.03 — Batimetria/hidrometria</option>
          <option value="7119-7/03">7119-7/03 — Desenho técnico</option>
        </select>

        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 10, marginTop: 16 }}>
          <button onClick={onClose}
            style={{ padding: '8px 16px', fontSize: 12, border: '0.5px solid #ddd',
              borderRadius: 5, background: '#fff', cursor: 'pointer' }}>Cancelar</button>
          <button onClick={salvar} disabled={salvando}
            style={{ padding: '8px 18px', fontSize: 12, fontWeight: 600, border: 'none',
              borderRadius: 5, background: '#0930D0', color: '#fff',
              cursor: salvando ? 'not-allowed' : 'pointer', opacity: salvando ? 0.5 : 1 }}>
            {salvando ? 'Salvando…' : 'Cadastrar e selecionar'}
          </button>
        </div>
      </div>
    </div>
  );
}
